// Product
import React from 'react'
import ReactDOM from 'react-dom'

import ProductMeta from '../productMeta'
import ProductSlider from '../productSlider'
import ProductTitle from '../productTitle'
import ProductDescription from '../productDescription'

class Product {
  constructor() {
    // liquid variables - see product.liquid
    this.productObject = product
    this.productOptionVals = productOptionVals
    this.productAdditionalVariantFields = productVariantInfo
    this.productSliderAssets = productSliderAssets
    this.productEmbroideryPricing = embroideryPricing
    this.selectedFont = embroideryFonts
    this.activeQty = 1
    this.currentVariant = this.productObject.variants[0]
    this.headerBanner=headerBanner
    this.productConnections=productConnections
    this.CurrentAssets=productSliderAssets.find(item => item.id === this.productObject.id)
    this.productTitle=this.productObject.title
    this.details=this.productOptionVals.find(item => item.id === this.productObject.id)
    this.currentProduct=product
    this.cgOptionTitle=cgOptionTitle
    this.renderReactMeta()
    this.renderReactSlider()
    this.renderTitleComponent()
    this.renderDescriptionComponent()
    // click events
    this.initEvents()
  }
  updateCurrentVariant(variant) {
    this.currentVariant = variant
    this.renderReactSlider()
  }
  updateSliderAssets(sliderAssets){
    this.CurrentAssets = sliderAssets;
    this.renderReactSlider()
  }
  updateProductTitle(title,details,product){
   this.productTitle=title
   this.details=details
   this.currentProduct=product
   this.renderTitleComponent()
   this.renderDescriptionComponent()
  }
  
  renderReactMeta() {
    const productMetaElement = document.getElementById('react-productmeta-component');
    if (productMetaElement) {
        const templateType = productMetaElement.getAttribute('template');
        ReactDOM.render(
            <ProductMeta
                setProductClassCurrentVariant={(variant) => this.updateCurrentVariant(variant)}
                setProductSliderAssets={(sliderAssets) => this.updateSliderAssets(sliderAssets)}
                setProductTitle={(title,details,product) => this.updateProductTitle(title,details,product)}
                productObject={this.productObject}
                productOptionVals={productOptionVals}
                productAdditionalVariantField={this.productAdditionalVariantFields}
                embroideryPricing={this.productEmbroideryPricing}
                selectedFont={this.selectedFont}
                thisProductPage={this}
                typeTemplate={templateType}
                headerBanner={this.headerBanner}
                productConnections={this.productConnections}
                productSliderAssets={this.productSliderAssets}
                cgOptionTitle={this.cgOptionTitle}
            />,
            productMetaElement
        );
    }
  }

  renderReactSlider() {
    ReactDOM.render((
      <ProductSlider productObject={this.productObject} currentVariant={this.currentVariant} productSliderAssets={this.CurrentAssets.assets} />), document.getElementById('react-productslider-component'))
  }
  renderTitleComponent() {
    const title = document.getElementById('react-title-component');
    if (title) {
      ReactDOM.render(
        <ProductTitle productname={this.productTitle} 
        baseLink="/" 
        basePath="Home" 
        currentPath={this.productTitle}
        grouping="breadcrumb--product" 
        subLink={this.details.sublink}
        subPath={this.details.subpath}
        currentProduct={this.currentProduct} />, 
        title 
      );
    }
  }
  renderDescriptionComponent() {
    const description = document.getElementById('react-product-description');
    if (description) {
      ReactDOM.render(
       <ProductDescription details={this.details} currentProduct={this.currentProduct}/>,
        description
      );
    }
  }
  


  initEvents() {
    this.sizeGuide()
  }

  sizeGuide() {
    const guideCover = document.querySelector('.size-guide__cover')
    const guideContent = document.querySelector('.size-guide__meta')

    this.sizeGuideToggles = [].slice.call(
      document.querySelectorAll('.size-guide__toggle')
    );

    this.sizeGuideToggles.forEach(toggle => {
      ['click', 'keypress'].forEach(event => {
        toggle.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {

            if (!guideCover.classList.contains('active')) {
              guideCover.classList.add('active');
              setTimeout(() => {
                guideContent.classList.add('active');
              }, 600);
            } else {
              guideContent.classList.remove('active');

              setTimeout(() => {
                guideCover.classList.remove('active');
              }, 600);
            }
          }
        });
      });
    });

    this.groupTabs = [].slice.call(
      document.querySelectorAll('.size-guide__tabs__item')
    );

    this.groupCollections = [].slice.call(
      document.querySelectorAll('.size-guide__table')
    );

    this.groupTabs.forEach(tab => {

      ['click', 'keypress'].forEach(event => {
        tab.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            let group = tab.dataset.group;

            [].forEach.call(this.groupTabs, function(el) {
              el.classList.remove('current');
            });

            [].forEach.call(this.groupCollections, function(el) {
              el.classList.remove('current');
            });

            tab.classList.add('current')

            this.groupCollections.forEach(collection => {
              if (collection.dataset.group === group) {
                collection.classList.add('current')
              }
            })
          }
        });
      });
    })
  }
}

const productInit = {
  init() {
    // if element exists init this class
    const productElem = [].slice.call(
      document.querySelectorAll('.product')
    );
    if (productElem.length > 0) {
      new Product();
    }
  },
};

export default productInit;
